module.exports = require('./lib/heap');



//////////////////
// WEBPACK FOOTER
// ./~/heap/index.js
// module id = 80
// module chunks = 0